import type {
  FindingsGroupBy,
  FindingsSeverity,
  FindingsStatusFilter,
  FindingsView,
} from '../findings-url';

export type RepositoryDefaultGroupArgs = {
  activeFilter: FindingsStatusFilter;
  activeView: FindingsView;
  activeRule: string | null;
  activeCode: string | null;
  activeCategory: string | null;
  activeSeverity: FindingsSeverity | null;
  activeTokenFilter: string | null;
  activeComponentFilter: string | null;
  searchQuery: string;
};

export function hasImplicitFindingRowFilter({
  activeFilter,
  activeRule,
  activeCode,
  activeCategory,
  activeSeverity,
  activeTokenFilter,
  activeComponentFilter,
  searchQuery,
}: RepositoryDefaultGroupArgs): boolean {
  return Boolean(
    activeFilter !== 'open' ||
      activeRule ||
      activeCode ||
      activeCategory ||
      activeSeverity ||
      activeTokenFilter ||
      activeComponentFilter ||
      searchQuery.trim(),
  );
}

export function resolveDefaultFindingsGroupBy(
  args: RepositoryDefaultGroupArgs,
): FindingsGroupBy {
  if (hasImplicitFindingRowFilter(args)) return 'none';
  return args.activeView === 'ci' ? 'pr' : 'decision';
}
